import React from 'react'
import { withFormsy } from 'formsy-react'
import MembershipCardAvatar from './MembershipCardAvatar'

function MembershipCardAvatarFormsy(props) {
  const value = props.value

  function setAvatar(input) {
    props.setValue(input)
  }

  return (
    <MembershipCardAvatar
      {...props}
      avatar={value}
      onAvatarSelect={setAvatar}
    />
  )
}

export default React.memo(withFormsy(MembershipCardAvatarFormsy))
